// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRightCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PRightCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PRightCircleOutlined = function PRightCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRightCircleOutlinedSvg
  }));
};

PRightCircleOutlined.displayName = 'PRightCircleOutlined';
export default React.forwardRef(PRightCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRightCircleOutlined.js
// module id = 3598
// module chunks = 0